import { IconButton, IconButtonProps, Tooltip } from "@mui/material";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { useIntl } from "react-intl";

type DownloadIconButtonProps = {
  label?: string;
} & IconButtonProps;

const DownloadIconButton = (props: DownloadIconButtonProps) => {
  const { formatMessage: t } = useIntl();
  return (
    <Tooltip title={t({ id: props.label ?? "download" })}>
      <IconButton {...props}>
        <CloudDownloadIcon />
      </IconButton>
    </Tooltip>
  );
};

export default DownloadIconButton;
